<app-state-section [state]="sectionState" [errorStateLabel]="'ErrorMessages.ErrorHappened' | translate">
  <form class="form-group flex column filter-form" [formGroup]="form" *ngIf="form">
    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.Status" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-control-full-width">
        <mat-select formControlName="status" panelClass="status-select-panel">
          <mat-select-trigger>{{ getStatusLabel(form.get('status')?.value) | translate }}</mat-select-trigger>
          <mat-option *ngFor="let option of statusOptions" [value]="option.value">
            <span class="status-option">
              <span class="status-option__label">{{ option.label | translate }}</span>
              <span class="status-option__count radius-2 text-900 small" *ngIf="option.value !== statusNone">{{ option.count }}</span>
            </span>
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field flex column" *ngIf="!isOrganizationUser && !isFleetUser">
      <mat-label class="field-label">{{ "Filter.Form.ReceiverName" | translate }}</mat-label>

      <app-lazy-dropdown
        formControlName="receiverId"
        [lookupExtraParams]="{customerId:userId}"
        [lookup]="LookupType.Receivers"
        [multiple]="true"
        [label]="'Filter.Form.Receiver'"
        [placeholder]="'Filter.Form.ReceiverName'"
      ></app-lazy-dropdown>
    </div>

    <div class="field flex column" *ngIf="isOrganizationUser || isFleetUser">
      <mat-label class="field-label">{{ "Filter.Form.CustomerName" | translate }}</mat-label>
      <app-lazy-dropdown
        formControlName="customerId"
        [lookupExtraParams]="{customerId:userId}"
        [lookup]="LookupType.Customers"
        [multiple]="true"
        [label]="'Filter.Form.Customer'"
        [placeholder]="'Filter.Form.CustomerName'"
      ></app-lazy-dropdown>
    </div>


    <div class="field flex column" *ngIf="isCustomerTypeSAAS && !isOrganizationUser && !isFleetUser">
      <mat-label class="field-label">{{ "Filter.Form.FleetName" | translate }}</mat-label>
      <app-lazy-dropdown
        formControlName="fleetId"
        [lookupExtraParams]="{customerId:userId}"
        [lookup]="LookupType.Fleets"
        [multiple]="true"
        [label]="'Filter.Form.Fleet'"
        [placeholder]="'Filter.Form.FleetName'"
      ></app-lazy-dropdown>
    </div>

    <div class="field flex column" *ngIf="!isOrganizationUser && !isFleetUser">
      <div class="field flex column">
        <mat-label class="field-label">{{ "Filter.Form.CreatedBy" | translate }}</mat-label>
        <app-lazy-dropdown
          formControlName="creator"
          [lookupExtraParams]="{customerId:userId}"
          [lookup]="LookupType.Users"
          [multiple]="true"
          [label]="'Filter.Form.Creator'"
          [placeholder]="'Filter.Form.CreatedBy'"
        ></app-lazy-dropdown>
      </div>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.PickupLocation" | translate }}</mat-label>
      <app-lazy-dropdown
        formControlName="fromCityId"
        [lookup]="LookupType.Cities"
        [multiple]="true"
        [label]="'Filter.Form.PickupLocation'"
        [placeholder]="'Filter.Form.PickupLocation'"
      ></app-lazy-dropdown>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "Filter.Form.DropOffLocation" | translate }}</mat-label>
      <app-lazy-dropdown
        formControlName="toCityId"
        [lookup]="LookupType.Cities"
        [multiple]="true"
        [label]="'Filter.Form.DropOffLocation'"
        [placeholder]="'Filter.Form.DropOffLocation'"
      ></app-lazy-dropdown>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "shipments.CustomerType" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-control-full-width">
        <mat-select formControlName="customerServiceType">
          <mat-option *ngFor="let option of shipmentCustomerTypes | enumToArray: customerTypesCustomLabels" [value]="option.value">
            {{ enumFilterTranslationKey + '.' + option.displayName | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "shipments.BayanIntegration" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-control-full-width">
        <mat-select formControlName="isBayanVerified">
          <mat-option *ngFor="let option of bayanTypes | enumToArray" [value]="option.value">
            {{ enumFilterTranslationKey + '.' + option.displayName | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "shipments.TripType" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-control-full-width">
        <mat-select formControlName="shipmentRequestFilterCount">
          <mat-option *ngFor="let option of shipmentRequestsMultiplicationTypes | enumToArray" [value]="option.value">
            {{ enumFilterTranslationKey + '.' + option.displayName | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "shipments.TrackingBy" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-control-full-width">
        <mat-select formControlName="trackingTypeFilter">
          <mat-option *ngFor="let option of trackingTypes | enumToArray: trackingTypesCustomLabels" [value]="option.value">
            {{ enumFilterTranslationKey + '.' + option.displayName | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>

    <div class="field flex column">
      <mat-label class="field-label">{{ "shipments.Direction" | translate }}</mat-label>
      <mat-form-field appearance="outline" class="form-control-full-width">
        <mat-select formControlName="direction">
          <mat-option *ngFor="let option of directions | enumToArray" [value]="option.value">
            {{ enumFilterTranslationKey + '.' + option.displayName | translate }}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </form>
</app-state-section>
